import { render, staticRenderFns } from "./present-records-list.vue?vue&type=template&id=aabb4a78&"
import script from "./present-records-list.vue?vue&type=script&lang=js&"
export * from "./present-records-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports